'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import UIList from 'UIComponents/list/UIList';
import Small from 'UIComponents/elements/Small';
import ScheduleSummary from './ScheduleSummary';

const LIAdSetSummary = ({
  entity,
  adAccount: {
    currencyCode
  }
}) => {
  const {
    totalBudget,
    dailyBudget,
    schedule
  } = entity;
  return /*#__PURE__*/_jsxs(UIList, {
    childClassName: "m-y-1",
    firstChildClassName: "m-bottom-1",
    children: [/*#__PURE__*/_jsx(ScheduleSummary, {
      schedule: schedule
    }), totalBudget && /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "campaigns.summary.budget.TOTAL",
          options: {
            budget: I18n.formatCurrency(totalBudget.value, {
              currencyCode
            })
          }
        })
      })
    }), !totalBudget && dailyBudget && /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "campaigns.summary.budget.DAILY",
          options: {
            budget: I18n.formatCurrency(dailyBudget.value, {
              currencyCode
            })
          }
        })
      })
    })]
  });
};

export default LIAdSetSummary;